import { httpClient } from './httpClient';
import { createViddLAdminRestDataProvider } from './viddl-admin-rest';

export default createViddLAdminRestDataProvider('', httpClient);
